import React from 'react';
import { useStyles, combine } from '@webapps/styles';
import { linkpickTheme } from '@webapps/styles';

export default function InviteModale() {
  const { classes } = useStyles(styles);

  // Fonction pour détecter si on est sur mobile
  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  // Fonction pour ouvrir Gmail
  const openGmail = () => {
    if (isMobile()) {
      // Sur mobile, essayer d'ouvrir l'app Gmail
      const gmailAppUrl = 'googlegmail://';
      const fallbackUrl = 'https://mail.google.com';

      // Essayer d'ouvrir l'app Gmail
      window.location.href = gmailAppUrl;

      // Si l'app n'est pas installée, rediriger vers le web après un délai
      setTimeout(() => {
        window.open(fallbackUrl, '_blank');
      }, 1000);
    } else {
      // Sur desktop, ouvrir Gmail dans le navigateur
      window.open('https://mail.google.com', '_blank');
    }
  };

  // Fonction pour ouvrir l'application mail par défaut
  const openDefaultMail = () => {
    // mailto: ouvre l'application mail par défaut sur tous les systèmes
    window.location.href = 'mailto:';
  };

  return (
    <div className={classes.container}>
      <div className={classes.buttonsSection}>
        <div className={classes.gmailButton} onClick={openGmail}>
          <div className={classes.iconContainer}>
            <img
              className={classes.icon}
              src="https://framerusercontent.com/images/Fk1Mlg2g4oYIP6i1jz7TfBEwQ.png"
              srcSet="https://framerusercontent.com/images/Fk1Mlg2g4oYIP6i1jz7TfBEwQ.png?scale-down-to=512 512w,https://framerusercontent.com/images/Fk1Mlg2g4oYIP6i1jz7TfBEwQ.png?scale-down-to=1024 1024w,https://framerusercontent.com/images/Fk1Mlg2g4oYIP6i1jz7TfBEwQ.png 1115w"
              sizes="15px"
              alt=""
            />
          </div>
          <div className={classes.buttonText}>Ouvrir Gmail</div>
        </div>
        <div className={classes.defaultMailButton} onClick={openDefaultMail}>
          Ouvrir ma boite mail par défaut
        </div>
      </div>
      <div className={classes.supportSection}>
        <div className={classes.supportText}>L'équipe de Linkpick</div>
        <div className={classes.supportText}>Une question ? Contactez-nous par mail via</div>
        <div className={classes.supportEmail}>support@linkpick.fr</div>
      </div>
    </div>
  );
}

const styles = () => {
  const { fontSizes2, gap, padding, colors } = linkpickTheme.params;

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
    },
    buttonsSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      width: '100%',
      maxWidth: '100%',
    },
    gmailButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.bleuElectrique,
      borderRadius: '40px',
      height: '40px',
      ...combine(padding.xs, padding.m),
      ...combine(gap.s),
      width: '100%',
      border: '1px solid transparent',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: colors.bleuSaphir,
      },
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.blanc,
      borderRadius: '30px',
      ...combine(padding.xs),
      width: 'min-content',
      height: 'min-content',
    },
    icon: {
      width: '15px',
      height: '15px',
    },
    buttonText: {
      fontFamily: '"Montserrat", sans-serif',
      ...combine(fontSizes2.body),
      fontWeight: '500',
      color: colors.blanc,
    },
    defaultMailButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.bleuPale,
      borderRadius: '40px',
      height: '40px',
      ...combine(padding.xs, padding.m),
      width: '100%',
      border: '1px solid transparent',
      fontFamily: '"Montserrat", sans-serif',
      ...combine(fontSizes2.body),
      fontWeight: '500',
      color: colors.bleuElectrique,
      cursor: 'pointer',
      '&:hover': {
        borderColor: colors.bleuElectrique,
      },
    },
    supportSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '4px',
      width: '100%',
      maxWidth: '100%',
    },
    supportText: {
      fontFamily: '"Roboto", sans-serif',
      ...combine(fontSizes2.body),
      textAlign: 'center',
      fontWeight: '400',
      color: colors.bleuArdoise,
      wordWrap: 'break-word',
      whiteSpace: 'normal',
      maxWidth: '100%',
      overflow: 'hidden',
    },
    supportEmail: {
      fontFamily: '"Roboto", sans-serif',
      ...combine(fontSizes2.body),
      textAlign: 'center',
      fontWeight: '400',
      color: colors.bleuElectrique,
      wordWrap: 'break-word',
      whiteSpace: 'normal',
      maxWidth: '100%',
      overflow: 'hidden',
    },
  };
};